import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';

const Mission = () => {
  const { t } = useTranslation();

  const goals = [
    'goal1', 'goal2', 'goal3', 'goal4', 'goal5', 'goal6', 'goal7',
    'goal8', 'goal9', 'goal10', 'goal11', 'goal12', 'goal13', 'goal14'
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-8 text-gray-900">
            {t('mission.title')}
          </h1>

          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <p className="text-xl text-gray-700 mb-10 text-center font-medium">
              {t('mission.intro')}
            </p>

            <div className="space-y-4">
              {goals.map((goal, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg hover:bg-red-50 transition-colors"
                >
                  <CheckCircle className="text-red-600 flex-shrink-0 mt-1" size={24} />
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {t(`mission.goals.${goal}`)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
